import React from 'react'
import Box from '@mui/material/Box'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { alpha, useTheme } from '@mui/material/styles'

// Segmented "pill" filter (All / Events / PTS / Rota …) with optional per-
// option counts. `options` is [{ value, label, icon? }] and `counts` an
// object keyed by value; the icon is hidden on phones to keep the pill
// narrow, and the pill scrolls sideways rather than pushing past the
// viewport.
//
//   <FilterPills
//     value={typeFilter}
//     onChange={setTypeFilter}
//     options={SHIFT_TYPE_FILTERS}
//     counts={typeCounts}
//   />
const FilterPills = ({ value, onChange, options, counts, ariaLabel, sx }) => {
  const theme = useTheme()
  const accent = theme.palette.anBlue.main

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      aria-label={ariaLabel}
      onChange={(e, next) => {
        if (next === null || next === undefined) return
        onChange(next)
      }}
      sx={{
        bgcolor: alpha(accent, 0.06),
        borderRadius: 1.5,
        p: 0.5,
        gap: 0.5,
        maxWidth: '100%',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        '& .MuiToggleButton-root': {
          border: 0,
          borderRadius: '10px !important',
          px: { xs: 1, sm: 1.5 },
          py: 0.5,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          textTransform: 'none',
          fontWeight: 700,
          color: 'text.secondary',
          gap: 0.75,
          '&.Mui-selected': {
            bgcolor: 'background.paper',
            color: accent,
            boxShadow: `0 2px 8px ${alpha(accent, 0.18)}`,
            '&:hover': { bgcolor: 'background.paper' },
          },
        },
        ...sx,
      }}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.icon && (
            <Box
              component="span"
              sx={{
                display: { xs: 'none', sm: 'inline-flex' },
                alignItems: 'center',
              }}
            >
              {option.icon}
            </Box>
          )}
          {option.label}
          {counts && (
            <Box
              component="span"
              sx={{
                px: 0.75,
                py: 0.1,
                borderRadius: 1,
                fontSize: 12,
                bgcolor:
                  value === option.value
                    ? alpha(accent, 0.1)
                    : alpha(theme.palette.text.primary, 0.06),
              }}
            >
              {counts[option.value] ?? 0}
            </Box>
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default FilterPills
